/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BankCardVo } from './BankCardVo';
import {
    BankCardVoFromJSON,
    BankCardVoFromJSONTyped,
    BankCardVoToJSON,
    BankCardVoToJSONTyped,
} from './BankCardVo';

/**
 * 
 * @export
 * @interface ResponseBankCardVo
 */
export interface ResponseBankCardVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseBankCardVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseBankCardVo
     */
    message?: string;
    /**
     * 
     * @type {BankCardVo}
     * @memberof ResponseBankCardVo
     */
    data?: BankCardVo;
}

/**
 * Check if a given object implements the ResponseBankCardVo interface.
 */
export function instanceOfResponseBankCardVo(value: object): value is ResponseBankCardVo {
    return true;
}

export function ResponseBankCardVoFromJSON(json: any): ResponseBankCardVo {
    return ResponseBankCardVoFromJSONTyped(json, false);
}

export function ResponseBankCardVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseBankCardVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : BankCardVoFromJSON(json['data']),
    };
}

export function ResponseBankCardVoToJSON(json: any): ResponseBankCardVo {
    return ResponseBankCardVoToJSONTyped(json, false);
}

export function ResponseBankCardVoToJSONTyped(value?: ResponseBankCardVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': BankCardVoToJSON(value['data']),
    };
}

